import React from 'react'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import Widget from '@jimmyboys/liita-ui/dist/components/Widget'
import LoadingIndicatorButton from 'components/LoadingIndicatorButton/LoadingIndicatorButton'

import ExpandableWidget from 'components/ExpandableWidget/ExpandableWidget'

import ActionButton from '@jimmyboys/liita-ui/dist/components/ActionButton'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import { useTaskManager } from 'store'
import { useFetchList } from 'store'
import Collection from '@jimmyboys/liita-ui/dist/components/Collection'
import { RemindersWidget } from 'components/widgets'
import Note from 'models/Note'
import useSession from 'hooks/useSession'

import styles from './ContextualController.module.sass'

const TaskStatsRow = (props) => {
	const { i18n } = useGlobal()
	const { data, ...attributes } = props
	return (
		<div {...attributes} className={styles['row']}>
			<h5>{i18n([data?.taskType ?? ''])}</h5>
			<small>{data?.count || 0}</small>
		</div>
	)
}

const ContextualHomepageController = () => {
	const { i18n } = useGlobal()
	const { openNextTask } = useTaskManager()
	const { user: sessionUser } = useSession()
	const [isLoading, setIsLoading] = React.useState(false)

	const statsUri = '/tasks/stats'
	const todayRemindersUri = `/notes/today_reminders?claimsManagerTrust=${sessionUser.legacyId}`
	const { contents } = useFetchList(
		[statsUri, todayRemindersUri],
		[undefined, Note.fromJSON]
	)
	const [statsData, reminders] = contents

	const isDoctor = sessionUser?.roles?.includes('doctor')
	return (
		<VStack
			className={styles['homepage-widget']}
			wrap='nowrap'
			gap='xsmall'
			justify='space-between'
		>
			<div>
				<Widget
					className={styles['welcome-widget']}
					paddings={['small', '', '']}
				>
					<h2 className={styles['welcome-title']}>{i18n`Welcome`}</h2>
					<small>{i18n`This is your working area.`}</small>
				</Widget>
				<RemindersWidget reminders={reminders} />
				<ExpandableWidget
					className={styles['aside-widget']}
					titleAppearance='aside-widget'
					heading='h5'
					title={i18n`User tasks`}
					expanded
					borderRadius
					margins={['small', '', '']}
					paddings={['', 'xsmall', 'xsmall']}
				>
					<Widget className={styles['aside-widget-content']}>
						{statsData?.userAllocationStats &&
						statsData.userAllocationStats.length ? (
							<>
								<div className={styles['list-header']}>
									<h5>&nbsp;</h5>
									<small>{i18n`No. Tasks`}</small>
								</div>
								<Collection
									itemsHeight={28}
									card={TaskStatsRow}
									items={statsData?.userAllocationStats}
								/>
							</>
						) : (
							<div>{i18n`No tasks in user`}</div>
						)}
					</Widget>
				</ExpandableWidget>
				{
					<ExpandableWidget
						className={styles['aside-widget']}
						titleAppearance='aside-widget'
						heading='h5'
						title={i18n`Pool tasks`}
						expanded
						borderRadius
						margins={['small', '', '']}
						paddings={['', 'xsmall', 'xsmall']}
					>
						<Widget className={styles['aside-widget-content']}>
							{statsData?.poolAllocationStats &&
							statsData.poolAllocationStats.length ? (
								<>
									<div className={styles['list-header']}>
										<h5>&nbsp;</h5>
										<small>{i18n`No. Tasks`}</small>
									</div>
									<Collection
										itemsHeight={28}
										card={TaskStatsRow}
										items={
											statsData?.poolAllocationStats || []
										}
									/>
								</>
							) : (
								<div>{i18n`No tasks in pool`}</div>
							)}
						</Widget>
					</ExpandableWidget>
				}
			</div>
			<ActionButton
				className={styles['tasks-button']}
				primary
				icon={isLoading ? null : 'chevron'}
				disabled={isLoading}
				onClick={async () => {
					setIsLoading(true)
					try {
						await openNextTask()
					} finally {
						setIsLoading(false)
					}
				}}
			>
				{isLoading ? (
					<LoadingIndicatorButton label={i18n`Loading...`} />
				) : (
					i18n`Start Tasks`
				)}
			</ActionButton>
		</VStack>
	)
}

export default ContextualHomepageController
